import AnomalyListIcon from '@resources/icons/AnomalyListIcon.svg?react';
import AnomalyWidgetIcon from '@resources/icons/AnomalyWidgetIcon.svg?react';
import CreateAnomalyIcon from '@resources/icons/CreateAnomalyIcon.svg?react';
import {
  TeiaViewer,
  ToolbarItem,
  ToolbarItemMenu,
  useTeiaSource,
  useViewerContext,
  useWidgetInfo,
} from '@stereograph/teiaviewer';
import { usePluginTranslation } from '@translation';
import { OpenAnomalyListWidgetCommand } from './command/OpenAnomalyListWidgetCommand';
import { OpenNewAnomalyWidgetCommand } from './command/OpenNewAnomalyWidgetCommand';
import { AnomalyUploadToolbarItem } from './components/AnomalyUploadToolbarItem';

export const ShowTeiaAnomalyMenu = () => {
  const { t } = usePluginTranslation();
  const source = useTeiaSource();

  return (
    <ToolbarItemMenu
      icon={AnomalyWidgetIcon}
      label={t('toolbar.anomalies.tooltip')}
      disabled={source === null}
      data-dd-action-name="toolbar.anomalies"
    >
      <CreateAnomalyToolbarItem />
      <OpenAnomalyResumeWidgetToolbarItem />
      {!!source && <AnomalyUploadToolbarItem source={source} />}
    </ToolbarItemMenu>
  );
};

const CreateAnomalyToolbarItem = () => {
  const { t } = usePluginTranslation();
  const { viewer } = useViewerContext<TeiaViewer>();
  const source = useTeiaSource();
  const { isOpened } = useWidgetInfo('TeiaAnomalyResume');

  if (!source) {
    return null;
  }

  const openCreateAnomalyWidget = () => {
    const firstCommand = new OpenNewAnomalyWidgetCommand(viewer, 'TeiaAnomalyResume', {
      projectId: source.projectId,
      isAnomalyCreation: true,
    });

    firstCommand.execute();
  };

  return (
    <ToolbarItem
      disabled={source === null}
      icon={CreateAnomalyIcon}
      label={t('toolbar.anomalies.create_anomaly.tooltip')}
      onClick={openCreateAnomalyWidget}
      active={isOpened}
      data-dd-action-name="toolbar.anomalies.create_anomaly"
    />
  );
};

const OpenAnomalyResumeWidgetToolbarItem = () => {
  const { t } = usePluginTranslation();
  const { viewer } = useViewerContext<TeiaViewer>();
  const source = useTeiaSource();
  const { isOpened } = useWidgetInfo('TeiaAnomalyResume');

  if (!source) {
    return null;
  }

  const openAnomalyResumeWidget = () => {
    const command = new OpenAnomalyListWidgetCommand(viewer, 'TeiaAnomalyResume', {
      projectId: source.projectId,
      isAnomalyCreation: false,
    });
    command.execute();
  };

  return (
    <ToolbarItem
      disabled={source === null}
      icon={AnomalyListIcon}
      label={t('toolbar.anomalies.anomaly_resume.tooltip')}
      onClick={openAnomalyResumeWidget}
      active={isOpened}
      data-dd-action-name="toolbar.anomalies.anomaly_resume"
    />
  );
};
